import { fromJS, Map, List } from 'immutable'
import {
  SET_USER_TAG_OPTIONS_PROCESSING,
  SET_USER_TAG_OPTIONS,
  SET_USER_TAG_OPTIONS_ERROR,
  SET_NEW_USER_TAG_OPTION,
  REMOVE_USER_TAG_OPTION,
} from './actions'

export const initialState = Map({
  userTagOptions: List(),
})

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_USER_TAG_OPTIONS:
      return state.withMutations((map) => {
        map.set('userTagOptions', fromJS(payload.data))
        map.set('processing', false)
        map.delete('error')
      })
    case SET_NEW_USER_TAG_OPTION:
      return state.withMutations((map) => {
        map.update('userTagOptions', (data) => data.set(data.size, fromJS(payload.data)))
        map.delete('error')
      })
    case REMOVE_USER_TAG_OPTION:
      return state.withMutations((map) => {
        const newState = map.get('userTagOptions').filter((o) => parseInt(o.get('id'), 10) !== parseInt(payload.data, 10))
        map.set('userTagOptions', newState)
      })
    case SET_USER_TAG_OPTIONS_PROCESSING:
      return state.withMutations((map) => {
        map.set('processing', true)
      })
    case SET_USER_TAG_OPTIONS_ERROR:
      return state.withMutations((map) => {
        map.set('processing', false)
        map.set('error', fromJS(payload))
      })
    default:
      return state
  }
}
